import { AcRouteCellExpand } from "../components/AcRouteCellExpand/AcRouteCellExpand";
import { datesNumToName } from "./dateHelpers";
import { formatNumToTime } from "./timeHelpers";

// TODO: move this method to dateHelpers and remove all duplicate code from the components
const getDates = (actualPairingDates: any) => {
  let dateObject = {};
  let dates = actualPairingDates.map(f => new Date(`${f}T00:00:00`));
  let monthKeys = actualPairingDates.map(f => new Date(`${f}T00:00:00`).getMonth()).filter((f, i, a) => a.indexOf(f) === i);
  monthKeys.forEach(key => {
    dateObject[key] = dates.filter(f => f.getMonth() === key).map(f => f.getDate());
  });
  let monthArr: string[] = Object.keys(dateObject);
  // single sceanrio to handle when Dec and Jan month pairings show up
  // to show first Dec and then Jan Dates
  if(monthArr[0]==='0' && monthArr[1] && monthArr[1]==='11'){
    let jan: string = monthArr.shift() || "";
    monthArr.push(jan);
  }
  const datesString = monthArr.map((f,index) => index===0?`${datesNumToName(f, 1)} ${dateObject[f].join(', ')}`:`, ${datesNumToName(f, 1)} ${dateObject[f].join(', ')}`).reduce((a, b) => a + b, '');
  return datesString;
};

export const columnsOptions = {
  pairingId: {
    width: 100,
    editable: false,
    sortComparator: (_) => true
  },
  days: {
    width: 70,
    editable: false,
    renderCell: (params) => {
      return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{params.row.days}</span>)
    }
  },
  credit: {
    width: 70, editable: false, valueGetter: ({ value }) => `${formatNumToTime(value)}`, renderCell: (params) => { return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{formatNumToTime(params.row.credit)}</span>) }
  },
  route: {
    editable: false,
    flex: 1,
    minWidth: 250,
    renderCell: AcRouteCellExpand,
    sortComparator: (_1, _2, param1, param2) => {
      const value1 = param1.api.getCellValue(param1.id, 'flightSegments')[0]?.segment || '';
      const value2 = param2.api.getCellValue(param2.id, 'flightSegments')[0]?.segment || '';
      return value1 > value2 ? 1 : -1;
    },
    valueGetter: ({ row }) => {
      return row.flightSegments.map(s => `${s.segment} ${s.layOver ? formatNumToTime(s.layOver) + ' ' : ''}`).reduce((a, b) => a + b, '');
    }
  },
  onduty: {
    width: 70, editable: false, valueGetter: ({ value }) => `${formatNumToTime(value)}`, headerClassName: 'two-line', renderCell: (params) => { return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{formatNumToTime(params.row.onduty)}</span>) }
  },
  offduty: {
    width: 70, editable: false, valueGetter: ({ value }) => `${formatNumToTime(value)}`, headerClassName: 'two-line', renderCell: (params) => { return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{formatNumToTime(params.row.offduty)}</span>) }
  },
  // maxduty: { width: 70, editable: false, headerClassName: 'two-line' },
  hoursPerDay: {
    width: 70, editable: false, valueGetter: ({ value }) => `${formatNumToTime(value)}`, headerClassName: 'two-line', renderCell: (params) => { return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{formatNumToTime(params.row.hoursPerDay)}</span>) }
  },
  expenses: {
    width: 95, editable: false, valueGetter: ({ value }) => `$${(value / 100).toFixed(2)}`, renderCell: (params) => { return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{`$${(params.row.expenses / 100).toFixed(2)}`}</span>) }
  },
  // caday: { width: 150, editable: false },
  dates: {
    width: 150,
    editable: false,
    valueGetter: ({ row }) => `${getDates(row.dates)}`,
    renderCell: (params) => {
      const dates = getDates(params.row.dates);
     let datesArray= dates?.split(",");
     let fourthIndex=datesArray[2];
     let indexAfterFourth=dates.indexOf(fourthIndex)+1;
      return (
        <span className={params.row.isDeleted ? 'pairing-list-row-opacity days' : 'days'} title={dates}>
          {indexAfterFourth<=0 ? dates:`${dates.substring(0,indexAfterFourth)}...`}
          
        </span>
      );
    },
    sortComparator: (_1, _2, param1, param2) => {
      const value1 = new Date(param1.value[0]+" 00:00");
      const value2 = new Date(param2.value[0]+" 00:00");
      return value1.getTime() !== value2.getTime() ? value1.getTime() - value2.getTime() : (param1.value[1] ? new Date(param1.value[1]+" 00:00").getTime() - value2.getTime() : ( param2.value[1] && value1.getTime() - new Date(param2.value[1]+" 00:00").getTime()));
    },
  },
  tafb: {
    width: 70, editable: false, valueGetter: ({ value }) => `${formatNumToTime(value)}`, renderCell: (params) => { return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{formatNumToTime(params.row.tafb)}</span>) }
  },
  eff: { width: 60, editable: false, renderCell: (params) => { return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{params.row.eff}</span>) }},
  fltNo: {
    width: 120, editable: false,
    valueGetter: ({ row }) => row.flightSegments.map((f, i, a) => {
      let fltDashed = f.fltNo.replace(',', '-');
      return a.length > 1 ? ((a.length - 1 !== i) ? `${fltDashed}, ` : `${fltDashed}`) : `${fltDashed}`;
    }).reduce((a, b) => a + b, ''),
    renderCell: (params) => {
      let fltNos = params.row.flightSegments.map((f, i, a) => {
        let fltDashed = f.fltNo.replace(',', '-');
        return a.length > 1 ? ((a.length - 1 !== i) ? `${fltDashed}, ` : `${fltDashed}`) : `${fltDashed}`;
      }).reduce((a, b) => a + b, '');
      return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity route' : 'route'} title={fltNos}>{fltNos}</span>);
    }
  },
  daycredit: {
    width: 80, editable: false, valueGetter: ({ value }) => `${formatNumToTime(value)}`, headerClassName: 'two-line', renderCell: (params) => { return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{formatNumToTime(params.row.daycredit)}</span>) }
  },
  nightcredit: {
    width: 80, editable: false, valueGetter: ({ value }) => `${formatNumToTime(value)}`, headerClassName: 'two-line', renderCell: (params) => { return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{formatNumToTime(params.row.nightcredit)}</span>) }
  },
  overseasCredit: {
    width: 80, editable: false, valueGetter: ({ value }) => `${formatNumToTime(value)}`, headerClassName: 'two-line', renderCell: (params) => { return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{formatNumToTime(params.row.overseasCredit)}</span>) }
  },
  dhCredit: {
    width: 80, editable: false, valueGetter: ({ value }) => `${formatNumToTime(value)}`, headerClassName: 'two-line', renderCell: (params) => { return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{formatNumToTime(params.row.dhCredit)}</span>) }
  },
  sectors: { width: 80, editable: false,renderCell: (params) => { return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{params.row.sectors}</span>) } },
  occurs: { width: 80, editable: false, renderCell: (params) => { return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{params.row.occurs}</span>) }},
  pairType: { width: 70, editable: false, headerClassName: 'two-line',
  renderCell: (params) => { return (<span className={params.row.isDeleted ? 'pairing-list-row-opacity' : ''}>{params.row.pairType}</span>) } },
  actions: {
    field: 'actions',
    headerName: ' ',
    width: 80,
    sortable: false,
    disableClickEventBubbling: true,
    cellClassName: 'justify-cell-center',
  },
};

export default columnsOptions;
